import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'
import { CompareSchemas } from '@gap/utils/utils'
import { OrgEntityType } from '@gap/backend/database/entities/OrgEntity'
import { OrgTypeEnumSchema } from './OrgTypeEnum'
import { tierNameDtoSchema } from '@gap/utils/tier/tier-config'
import { countryCodeEnumSchema } from '../../location/models/CountryDto'
import { currencyCodeEnum } from '@gap/utils/country/countryList'
import validationConstants from '@gap/utils/validation/validation-constants'
import { orgSizeEnumSchema } from './OrgSizeEnum'

const OrgEntityDtoSchema = z.object({
   id: z.string({ errorMap }),
   name: z.string({ errorMap }).max(validationConstants.orgEntity.maxNameLength),
   taxOrgId: z.string().max(validationConstants.orgEntity.maxTaxOrgIdLength).optional(),
   website: z.string().max(validationConstants.orgEntity.maxWebsiteLength).optional(),
   contactNumber: z.string().max(validationConstants.orgEntity.maxPhoneNumberLength).optional(),
   logo: z.string().optional(),
   address: z.string().max(validationConstants.orgEntity.maxAddressLength).optional(),
   orgType: OrgTypeEnumSchema,
   orgSize: orgSizeEnumSchema.optional(),
   tierName: tierNameDtoSchema.optional(),
   tierMaxUsers: z
      .number()
      .min(validationConstants.orgEntity.minTierMaxUsersLength)
      .max(validationConstants.orgEntity.maxTierMaxUsersLength)
      .optional(),
   countryCode: countryCodeEnumSchema.optional(),
   currencyCode: z.enum(currencyCodeEnum).optional(),
   taxDescription: z.string().max(validationConstants.orgEntity.maxTaxDescriptionLength).optional(),
   taxPercentage: z
      .number()
      .min(validationConstants.orgEntity.minTaxPercentageLength)
      .max(validationConstants.orgEntity.maxTaxPercentageLength)
      .optional(),
   trialEndDate: z.string().optional(),
   adminUserId: z.string(),
   timezone: z.string().max(validationConstants.orgEntity.maxTimezoneLength),
   xeroAuthorised: z.boolean(),
   xeroLastUpdated: z.string().optional(),
   createdAt: z.string(),
   createdBy: z.string(),
   lastUpdatedAt: z.string(),
   lastUpdatedBy: z.string(),
   advisorOrgId: z.string().optional(),
   xeroDisconnectedViaXPM: z.boolean().optional(),
   xpmName: z.string().optional(),
   businessPlanFinalisedDate: z.string().optional(),
   demoDocId: z.string().optional(),
   advisorOrgQuickstart: z
      .object({
         orgSetup: z.boolean().optional(),
      })
      .optional(),
   betaFeaturesOptIn: z.boolean().optional(),
})

// Ensure schema is equal to entity. Note, electrodb's EntityItem doesnt have support for optional types, but atleast we can check for variables
0 as CompareSchemas<z.output<typeof OrgEntityDtoSchema>, OrgEntityType>

export default OrgEntityDtoSchema
